import React from 'react'
import { Button } from 'components'
import './Style.css'
import CloseIcon from '@mui/icons-material/Close'
import { translate } from 'locales'
import useFetch from 'hooks/useFetch'
import useStorage from 'hooks/storageSync'
import tagSelectorAnalytics from 'services/analytics/MedicalRecord/tagSelectorAnalytics'

const TagSelector: React.FunctionComponent<{ scheduleUUID: string }> = ({
  scheduleUUID,
}) => {
  const [storage, setStorage]: any = useStorage(scheduleUUID, `tags`)

  const { data } = useFetch({
    url: 'doctors/ms/v1/medical-record/tags',
    options: {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  })

  const filterSelectedDoctor = data?.filter((item: { id: string }) =>
    storage?.tags?.tagsDoctor?.includes(item.id)
  )

  const trackPayload = (tagId: string) => ({
    tagId,
    scheduleId: scheduleUUID,
  })

  const addTag = (tagId: string, type: 'tagsDoctor' | 'tagsPatient'): void => {
    const tags = storage?.tags?.[type] || []
    setStorage(type, [...tags, tagId])
  }

  const removeTag = (
    tagId: string,
    type: 'tagsDoctor' | 'tagsPatient'
  ): void => {
    const removed = storage?.tags?.[type]?.filter(
      (item: string) => item !== tagId
    )
    setStorage(type, removed)
  }

  const handleAddDoctorTag = (tag: { id: string; title: string }): void => {
    tagSelectorAnalytics.trackDoctorTagAdd(trackPayload(tag.id))
    addTag(tag.id, 'tagsDoctor')
  }

  const handleRemoveDoctorTag = (tag: { id: string; title: string }): void => {
    tagSelectorAnalytics.trackDoctorTagRemove(trackPayload(tag.id))
    removeTag(tag.id, 'tagsDoctor')
  }

  return (
    <div style={{ marginTop: 20 }} data-testid="tag-selector-doctor">
      <span data-testid="tag-selector-doctor-heading">{`${translate(
        'medicalRecord.perceivedDemand'
      )} *`}</span>
      <div className="tag-container" data-testid="tag-selector-doctor-selected">
        {filterSelectedDoctor?.map((tag: { id: string; title: string }) => (
          <Button
            key={tag.id}
            color="tag-active"
            type="button"
            className="tag-button"
            dataTestId={`tag-selector-doctor-selected-${tag.id}`}
            ariaLabel={`${translate(
              'medicalRecord.doctorTagRemoveButtonAria'
            )} ${tag.title}`}
            onClick={() => {
              handleRemoveDoctorTag(tag)
            }}
          >
            <span>{tag.title}</span>
            <CloseIcon fontSize="small" />
          </Button>
        ))}
      </div>
      {data && (
        <div
          className="tag-container"
          data-testid="tag-selector-doctor-available"
        >
          {data?.map((tag: { id: string; title: string }) => (
            <Button
              color="tag"
              type="button"
              className="tag-button"
              key={tag.id}
              dataTestId={`tag-selector-doctor-option-${tag.id}`}
              ariaLabel={`${translate(
                'medicalRecord.doctorTagAddButtonAria'
              )} ${tag.title}`}
              onClick={() => {
                handleAddDoctorTag(tag)
              }}
              disabled={storage?.tags?.tagsDoctor?.includes(tag.id)}
            >
              {tag.title}
            </Button>
          ))}
        </div>
      )}
    </div>
  )
}

export default TagSelector
